import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  getDocs,
  orderBy,
  Timestamp,
  limit,
} from "firebase/firestore";
import { db } from "../../../firebase-config";
import ReactApexChart from "react-apexcharts";
import Card from "@mui/material/Card";

export default function ForexChart({ monthValue, currency }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = React.useState(true);

  const firstDate = new Date();
  const lastDate = new Date();
  let firstTimestamp = React.useRef();
  let lastTimestamp = React.useRef();

  if (typeof monthValue === "number") {
    lastDate.setMonth(lastDate.getMonth() - monthValue);
    const firstYear = firstDate.getFullYear();
    const firstDay = firstDate.getDate();
    const firstMonth = firstDate.getMonth() + 1;

    const lastMonth = lastDate.getMonth();
    const lastYear = lastDate.getFullYear();
    const lastDay = lastDate.getDate();
    firstTimestamp = Timestamp.fromDate(
      new Date(`${firstYear}-${firstMonth}-${firstDay}`)
    );
    lastTimestamp = Timestamp.fromDate(
      new Date(`${lastYear}-${lastMonth}-${lastDay}`)
    );
  } else if (monthValue === "all") {
    lastDate.setFullYear(2000);
    const firstYear = firstDate.getFullYear();
    const firstDay = firstDate.getDate();
    const firstMonth = firstDate.getMonth() + 1;

    const lastMonth = lastDate.getMonth() + 1;
    const lastYear = lastDate.getFullYear();
    const lastDay = lastDate.getDate();
    firstTimestamp = Timestamp.fromDate(
      new Date(`${firstYear}-${firstMonth}-${firstDay}`)
    );
    lastTimestamp = Timestamp.fromDate(
      new Date(`${lastYear}-${lastMonth}-${lastDay}`)
    );
  }

  useEffect(() => {
    setLoading(true);

    async function getDocuments({ firstTimestamp, lastTimestamp, currency }) {
      const q = query(
        collection(db, "forex"),
        where("currency", "==", currency),
        where("date", "<=", firstTimestamp),
        where("date", ">=", lastTimestamp),
        orderBy("date"),
        // limit(10)
      );
      const allDocs = [];
      const querySnapshot = await getDocs(q);

      querySnapshot.forEach((doc) => {
        allDocs.push(doc.data());
      });

      //   const allDateRates = [];
      const meanRates = [];
      const buyRates = [];
      const sellRates = [];

      allDocs.forEach((e) => {
        const _date = e["date"];
        // const Rate = e["rate"];
        const mean = e["mean"];
        const buy = e["buy"];
        const sell = e["sell"];
        const date = _date.toDate().getTime();
        // const dateRate = [date, Rate];
        const meanRate = [date, mean];
        const buyRate = [date, buy];
        const sellRate = [date, sell];
        // allDateRates.push(dateRate);
        meanRates.push(meanRate);
        buyRates.push(buyRate);
        sellRates.push(sellRate);
      });
      setData([
        {
          name: "Sell",
          data: sellRates,
        },
        {
          name: "Mean",
          data: meanRates,
        },
        {
          name: "Buy",
          data: buyRates,
        },
      ]);
      setLoading(false);
    }
    getDocuments({
      firstTimestamp: firstTimestamp,
      lastTimestamp: lastTimestamp,
      currency: currency,
    });
  }, [currency]);

  const options = {
    theme: {
      mode: "dark",
    },
    chart: {
      type: "area",
      height: 400,
      colors: ["#008FFB", "#00E396", "#CED4DC"],
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      type: "datetime",
    },
    tooltip: {
      x: {
        format: "dd MMM yyyy",
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        opacityFrom: 0.6,
        opacityTo: 0.8,
      },
    },
    title: {
      text: "Foreign Exchange Rates",
      align: "center",
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  };

  return loading ? (
    <h1>Loading</h1>
  ) : (
    <>
      {data.length > 0 ? (
        <Card>
          <ReactApexChart
            options={options}
            series={data}
            height={400}
            type="area"
          />
        </Card>
      ) : (
        <h1>No Data Available</h1>
      )}
    </>
  );
}
